import { PublishPaymentMethodItem } from '../apis/types/payment'
import { isNeedAdyen3DS2Challenge } from '../payments/adyenDropIn'
import { isNeedPayermax3DS2Challenge } from '../payments/payermaxDropin'
import { isNeedChecus3DS2Challenge } from '../payments/checusDropin'

/** 判断是否支付失败 */
export const isOrderFailed = (paymentMethod: PublishPaymentMethodItem, result_data: any) => {
  switch (paymentMethod.payment_channel_type) {
    case 4:
    // checus 与 payermax 同构：建单 code 非 APPLY_SUCCESS 即失败
    case 10:
      return result_data?.code !== 'APPLY_SUCCESS'
  }
  return false
}

/** 判断是否需要3DS2挑战 */
export const isNeed3DS2Challenge = (paymentMethod: PublishPaymentMethodItem, result_data: any) => {
  switch (paymentMethod.payment_channel_type) {
    case 1:
      return isNeedAdyen3DS2Challenge(result_data)
    case 4:
      return isNeedPayermax3DS2Challenge(result_data)
    case 10:
      return isNeedChecus3DS2Challenge(result_data)
  }

  return false
}
